import { useState, useEffect } from 'react';
import { IonPage, IonContent } from '@ionic/react';
import { useLocation } from 'react-router-dom';
import { getClientById } from '../services/clientService';
import { getPropertyById } from '../services/propertyService';
import { useBreadcrumbStore } from '../store/useBreadcrumbStore';
import { TeamList } from '../components/teams/TeamList';

export default function TeamsPage() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const clientId = params.get('clientId') || undefined;
  const propertyId = params.get('propertyId') || undefined;

  const [contextName, setContextName] = useState('');
  const setBreadcrumb = useBreadcrumbStore((s) => s.set);

  useEffect(() => {
    if (location.pathname !== '/teams') return;
    if (propertyId && clientId) {
      Promise.all([getPropertyById(propertyId), getClientById(clientId)]).then(([prop, client]) => {
        setContextName(prop.name || propertyId);
        setBreadcrumb([
          { label: 'Clients', path: '/clients' },
          { label: client.name || clientId, path: `/client-detail?clientId=${clientId}` },
          { label: 'Properties', path: `/properties?clientId=${clientId}` },
          { label: prop.name || propertyId },
          { label: 'Teams' },
        ]);
      });
    } else if (propertyId) {
      getPropertyById(propertyId).then((prop) => {
        const name = prop.name || propertyId;
        setContextName(name);
        if (prop.clientId) {
          getClientById(prop.clientId).then((client) => {
            setBreadcrumb([
              { label: 'Clients', path: '/clients' },
              { label: client.name || prop.clientId!, path: `/client-detail?clientId=${prop.clientId}` },
              { label: 'Properties', path: `/properties?clientId=${prop.clientId}` },
              { label: name },
              { label: 'Teams' },
            ]);
          });
        } else {
          setBreadcrumb([
            { label: 'Properties', path: '/properties' },
            { label: name },
            { label: 'Teams' },
          ]);
        }
      });
    } else if (clientId) {
      getClientById(clientId).then((client) => {
        const name = client.name || clientId;
        setContextName(name);
        setBreadcrumb([
          { label: 'Clients', path: '/clients' },
          { label: name, path: `/client-detail?clientId=${clientId}` },
          { label: 'Teams' },
        ]);
      });
    } else {
      setContextName('');
      setBreadcrumb([{ label: 'Teams' }]);
    }
  }, [location.pathname, clientId, propertyId, setBreadcrumb]);

  const title = contextName ? `Teams - ${contextName}` : 'Teams';

  return (
    <IonPage>
      <IonContent>
        <TeamList title={title} clientId={clientId} propertyId={propertyId} />
      </IonContent>
    </IonPage>
  );
}
